import _ from 'underscore';

class RowTemplateBuilder {
	constructor(modules = null, field = null) {
		this.slug = null;
		this.template = '';

		// TODO - Deal with allowing the module/template itself passed into constructor
		if (module !== null && field !== null) {
			this.slug = field.slug;
			this.relatedModule = modules[ field.specific_data ];
			this.template = this.relatedModule.row_output_template;
			if (_.isObject(field.config) && field.config.row_output_template) {
				this.template = field.config.row_output_template;
			}
		}

		// eslint-disable-next-line no-useless-escape
		this.matcher = /\{\{\s*([^\}]*?)\s*\}\}/ug;
	}

	static moduleRowValue(module, row) {
		if (module.row_output_template) {
			const Builder = new RowTemplateBuilder(module);
			Builder.template = module.row_output_template;
			const name = Builder.convertRow(row);

			if (name && name.length > 0) {
				return name;
			}
		}

		return null;
	}

	convert(row, slug = false) {
		return (row[ slug || this.slug ] || []).map((row) => this.convertRow(row));
	}

	convertRow(row) {
		return (this.template || '').replace(this.matcher, (match, token) => RowTemplateBuilder.handleVariable(token, row));
	}

	setTemplate(template) {
		this.template = template;
	}

	static handleVariable(token, relatedItem) {
		const parts = token.split('.');
		if (parts.length > 1) {
			// This is a nested variable
			const namespace = parts.shift();
			if (typeof relatedItem[ namespace ] !== 'undefined') {
				return RowTemplateBuilder.handleVariable(parts.join('.'), relatedItem[ namespace ]);
			}
			return 'nested';
		} else if (typeof relatedItem[ parts ] !== 'undefined') {
			return relatedItem[ parts ];
		}

		return '';
	}
}

export default RowTemplateBuilder;
